// extracted by mini-css-extract-plugin
export default {"root":"FormSection_root__D0QvK"};